<template>
  <!-- 
    name: 新颜
   -->
  <div class="zuxianzhi d-c-c">
    <div v-if="!show" style="margin-top: 40px; width: 800px;">
      <div style="text-indent: 2em;">
        <p>提示：请生成报告后再查看该报告！</p>
        <p>新颜报告没有生成</p>
      </div>
      <div class="d-s-c d-r" style="margin: 0;">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="(item, index) in typeOptions"
            :label="item.label"
            :value="item.value"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          type="warning"
          style="margin-left: 20px;"
          plain
          size="large"
          @click="createReport"
          >点击查看租先知报告</el-button
        >
      </div>
    </div>
    <div v-else class="zxz_info_box">
      <el-button
        icon="el-icon-refresh"
        type="warning"
        plain
        @click="reCreateVisible = true"
        class="info_refresh_btn"
      ></el-button>

      <div>请求编号：{{ request_id }}</div>
      <!-- 报告 -->
      <h1>报告</h1>

      <!-- 个人信息 -->
      <div class="zxz_b_content d-s-c d-r">
        <table v-if="basic_info.length !== 0">
          <tr>
            <td colspan="8">
              <h2>个人信息</h2>
            </td>
          </tr>
          <tr
            v-for="(item, index) in basic_info"
            :key="index"
            style="width: 100%;"
          >
            <td
              v-for="(value, key) in item"
              :class="key % 2 === 0 ? 'bold' : ''"
              :key="key"
              style="width: 12.5%;"
            >
              {{ value }}
            </td>
          </tr>
        </table>
      </div>

      <!-- 雷达 -->
      <template v-if="info.report.radar">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="radar_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>雷达</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in radar_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style="width: 12.5%;"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 当前逾期 -->
      <template v-if="info.report.tanza">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="overdue_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>当前逾期</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in overdue_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style="width: 12.5%;"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 黑名单 -->
      <template v-if="info.report.zblacklist">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="blacklist_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>黑名单</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in blacklist_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style=""
              >
                <div v-for="(v, i) in value" class="d-b-c d-r">
                  <span class="gray" style="font-weight: bold;">{{
                    staticMap[i]
                  }}</span
                  ><span>{{ v }}</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 多头监控 -->
      <template v-if="info.report.zlengding">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="zld_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>多头监控</h2>
              </td>
            </tr>
            <template v-for="(item, index) in zld_info">
              <tr v-if="index % 2 === 0" style="width: 100%;">
                <td colspan="8">
                  <h3>{{ item }}</h3>
                </td>
              </tr>
              <tr v-else v-for="(list, i) in item">
                <td
                  v-for="(value, key) in list"
                  :class="i === 0 || key === 0 ? 'bold' : ''"
                  :key="key"
                  style="width: 10%;"
                >
                  <!-- <div v-if ></div> -->
                  <span class="word-wrap">{{ value }}</span>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </template>

      <!-- 借贷履约记录 -->
      <template v-if="info.report.snxyp">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="loan_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>借贷履约记录</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in loan_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'long_td' : 'short_td'"
                :key="key"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 高危风险核查 -->
      <template v-if="info.report.highrisk">
        <div class="zxz_b_content d-s-c d-r">
          <table style="width: 100%">
            <tr>
              <td>
                <h2>高危风险核查</h2>
              </td>
              <td style="width: 80%; text-align: center; font-size: 20px;">
                <span class="blue">{{ info.report.highrisk }}</span>
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 风险标签 info.report.riskable -->
      <template v-if="info.report.riskable">
        <div class="zxz_b_content d-s-c d-r">
          <table style="width: 100%">
            <tr>
              <td>
                <h2>风险标签</h2>
              </td>
              <td style="width: 80%; text-align: center; font-size: 20px;">
                <span class="blue">{{ info.report.riskable }}</span>
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 涉诉记录 -->
      <template v-if="info.report.plinfp">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="plf_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>个人涉诉</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in plf_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style="width: 12.5%;"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- 特殊名单验证 -->
      <template v-if="info.report.speclist">
        <div class="zxz_b_content d-s-c d-r">
          <table v-if="spec_info.length !== 0">
            <tr>
              <td colspan="8">
                <h2>个人涉诉</h2>
              </td>
            </tr>
            <tr
              v-for="(item, index) in spec_info"
              :key="index"
              style="width: 100%;"
            >
              <td
                v-for="(value, key) in item"
                :class="key % 2 === 0 ? 'bold' : ''"
                :key="key"
                style="width: 25%;"
              >
                {{ value }}
              </td>
            </tr>
          </table>
        </div>
      </template>
    </div>

    <el-dialog
      title="重新生成报告"
      :visible.sync="reCreateVisible"
      width="600px"
    >
      <div class="d-s-c d-r" style="margin: 0; height: 100px;">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="(item, index) in typeOptions"
            :label="item.label"
            :value="item.value"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          type="warning"
          style="margin-left: 20px;"
          plain
          size="large"
          @click="createReport"
          >点击查看租先知报告</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import useApi from "@/api/useApi";
import Mapper, { xyReqHandle, plf_map } from "./common/staticMap";
export default {
  props: ["report", "order_id", "userInfo"],
  data() {
    return {
      show: true,
      reCreateVisible: false,
      form: {
        telephone: "",
        name: "",
        idcardno: "",
        type: "radar",
        key: "xy"
      },
      typeOptions: [
        { label: "雷达", value: "radar" },
        { label: "当前逾期", value: "tanza" },
        { label: "云黑名单", value: "zblacklist" },
        { label: "三要素验证", value: "trueman" },
        { label: "基础状态", value: "basestatus" },
        { label: "个人涉诉", value: "plinfp" },
        { label: "高风险核查", value: "highrisk" },
        { label: "借贷履约记录", value: "snxyp" },
        { label: "偿债压力", value: "debtstress" },
        { label: "团伙欺诈排查", value: "fraudgrop" },
        { label: "3C租聘申请记录", value: "apply3c" },
        { label: "特殊名单验证", value: "speclist" },
        { label: "法院限高被执行人", value: "execlimit" }
      ],
      omit: ["Banks", "Non-bankFin", "Others"],
      info: {
        report: {},
        basic: {}
      },
      basic_info: [],
      radar_info: [],
      overdue_info: [],
      blacklist_info: [],
      zld_info: [], // 多头
      loan_info: [], // 借款
      plf_info: [], // 涉诉
      spec_info: [], // 特殊名单验证
      staticMap: {}
    };
  },
  methods: {
    /// 生成报告
    async createReport() {
      const params = { ...this.form, order_id: this.order_id };
      const type = this.form.type;
      const { data, msg } = await useApi().getReportByKey(params);
      if (Object.keys(data).length === 0) return;
      xyReqHandle(JSON.parse(data), this.info, this.form.type);
      this.formatData();
      this.show = true;
    },
    // 映射处理 -> 对象转换成 八个一行的二位数组
    mapData(target /** string */, origin /** obj */) {
      if (!origin || origin === null || Object.keys(origin).length === 0)
        return;
      let arr = [];
      Object.entries(origin).map(([key, value], index) => {
        if (index % 4 === 0 && index !== 0) {
          this[target].push(arr);
          arr = [];
        }
        arr.push(Mapper[key] ? Mapper[key] : key);
        arr.push(value);
      });
      if (arr.length > 0) this[target].push(arr);

      // console.log(this[target]);
    },
    // 特殊处理
    specialHandle(target /** string */, origin /** obj */) {
      if (!origin || origin === null || Object.keys(origin).length === 0)
        return true && (target = [["未查得"]]);
      if (target === "plf_info") {
        const res = origin.data;
        if (!res.resultDetails) {
          this[target] = [[res.respDesc]];
          return;
        }
        let arr = [],
          temp = [];
        res.resultDetails.allList.map((item, index) => {
          /** 没有数据test，若出现问题请着重查看此处 */
          const { dataType } = item;
          const data = item[dataType];
          temp.push(Mapper[dataType]);
          plf_map[dataType].forEach((key, i) => {
            if (i % 4 === 0 && i !== 0) {
              temp.push(arr);
              arr = [];
            }
            arr.push(Mapper[key]);
            arr.push(data[key]);
          });
          temp.push(arr);
          arr = [];
        });
        return;
      }
      if (target === "spec_info") {
        this[target] = [
          ['风险策略结果', origin.Rule.result.final_decision, '规则权重', origin.Rule.result.final_weight],
        ]
        console.log(this.spec_info)
      }
    },
    // 格式化数据
    formatData() {
      const target = this.info.report;
      const handleMap = {
        basic_info: this.info.basic,
        radar_info: target.radar,
        overdue_info: target.tanza,
        blacklist_info: target.zblacklist,
        zld_info: target.zlengding
      };
      const specialHandleMap = {
        plf_info: target.plinfp,
        spec_info: target.speclist
      };
      target.snxyp && (handleMap["loan_info"] = target.snxyp.data);
      Object.entries(handleMap).map(([i, v]) => this.mapData(i, v));
      Object.entries(specialHandleMap).map(([i, v]) =>
        this.specialHandle(i, v)
      );
    }
  },
  created() {
    this.staticMap = Mapper;

    this.form.telephone = this.userInfo.mobile;
    this.form.name = this.userInfo.username;
    this.form.idcardno = this.userInfo.usernum;

    this.show = this.report === "[]" || this.report === "" || this.report === undefined || this.report === null ? false : true;
    if (!this.show) return;
    const detail = JSON.parse(this.report)
      .filter(i => i.zu_describe === "xy")
      .pop();
    if (detail) {
      const res = JSON.parse(detail.zu_values);
      console.log(res);
      this.request_id = res.request_id;
      detail.zu_type === "basestatus"
        ? (this.info.basic = res.data)
        : (this.info.report[detail.zu_type] = res.data);
      detail.zu_type === "zblacklist" && (this.info.report[detail.zu_type] = res.data.blacklist);
    } else this.show = false;
    this.formatData();
  }
};
</script>

<style lang="scss" scoped>
@import "./common/report.scss";
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/xinYan.vue